import { render, staticRenderFns } from "./RenderGasPrice.vue?vue&type=template&id=64d7d184&scoped=true&"
import script from "./RenderGasPrice.vue?vue&type=script&lang=js&"
export * from "./RenderGasPrice.vue?vue&type=script&lang=js&"
import style0 from "./RenderGasPrice.vue?vue&type=style&index=0&id=64d7d184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7d184",
  null
  
)

export default component.exports